<template>
    <CommonHeader class="main_head_block">
		<template v-slot:header>
		<span class="module_heading">Add ASIN Scraper</span>
        </template>
	</CommonHeader>
</template>

<script>
import CommonHeader from "@/components/CommonHeader.vue"
export default {
	name:'AsinScraperListHeader',
    components:{CommonHeader},
}
</script>

<style lang="scss">

</style>
